import { TraitRegistryCategory } from '../TraitRegistryCategory';
import { TraitTypeSelect } from '../traitTypes/TraitTypeSelect';
import { TraitTypeNumeric } from '../traitTypes/TraitTypeNumeric';
export class TraitRegistryActor extends TraitRegistryCategory {
    label = 'Actor';
    constructor(parent) {
        super(parent);
        super.init();
    }
    actorRoleName = () => new TraitTypeSelect({
        default: '' /*
        label: 'Rollenname',
        select: [['taskDescription'], ['mainImage'], ['subText']] */
    });
    commentLegacyId = () => new TraitTypeNumeric();
}
